export default {"src":"/_next/static/media/error.1bb1ec2c.svg","height":408,"width":612,"blurWidth":0,"blurHeight":0};